import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, IconButton } from '@mui/material';
import { MenuRounded } from '@mui/icons-material';
import Sidebar, { SIDEBAR_WIDTH } from './Sidebar';

// Persistent sidebar shell for every authenticated page — no top bar.
// Pages render into <Outlet/>. On mobile widths (where the sidebar becomes
// an overlay drawer instead of a permanent rail) a small floating menu
// button opens it, since that button used to live in the now-removed
// TopBar.
export default function DashboardLayout() {
    const [mobileOpen, setMobileOpen] = React.useState(false);

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <IconButton
                    onClick={() => setMobileOpen(true)}
                    sx={{
                        display: { xs: 'inline-flex', md: 'none' },
                        m: 1.5,
                        bgcolor: 'rgba(255,255,255,0.06)',
                        '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                    }}
                >
                    <MenuRounded />
                </IconButton>
                <Box component="main" sx={{ p: { xs: 2, sm: 3, md: 4 }, pt: { xs: 0, md: 4 } }}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
}
